import { render, staticRenderFns } from "./CardRegister.vue?vue&type=template&id=3e859064&"
import script from "./CardRegister.vue?vue&type=script&lang=js&"
export * from "./CardRegister.vue?vue&type=script&lang=js&"
import style0 from "./CardRegister.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports